import _ from 'lodash';
import { observable, action } from 'mobx';
import type { ShareholderTicketFeeArgs } from '@this/domain/shareholder_ticket_fee/shareholder_ticket_fee';
import ShareholderTicketFee from '@this/domain/shareholder_ticket_fee/shareholder_ticket_fee';

export type ShareholderTicketFeeType = 'default' | 'organization' | 'not_entered';

class ShareholderTicketFeeList {
  @observable public list: ShareholderTicketFee[];

  @observable
  public feeType: ShareholderTicketFeeType = 'default';

  constructor(raw: ShareholderTicketFeeArgs[], feeType: ShareholderTicketFeeType = 'default') {
    this.list = raw.map(fee => new ShareholderTicketFee(fee));
    this.feeType = feeType;
  }

  setOrganizationId(organizationId: number | null) {
    this.list.forEach(fee => fee.setOrganizationId(organizationId));
    app.render();
  }

  find(id?: number) {
    if (!id) return undefined;
    return _.find(this.list, fee => fee.id === id);
  }

  @action
  push(fee: ShareholderTicketFee) {
    this.list.push(fee);
  }

  @action
  remove(fee: ShareholderTicketFee) {
    const i = this.list.indexOf(fee);
    if (i > -1) this.list.splice(i, 1);
  }

  @action
  update(newShareholderTicketFee: ShareholderTicketFee) {
    const fee = this.find(newShareholderTicketFee.id);
    if (fee) _.assign(fee, newShareholderTicketFee);
  }
}

export default ShareholderTicketFeeList;
